import { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet.heat';
import type { VarietyRecord } from './types';

interface HeatmapLayerProps {
  records: VarietyRecord[];
}

export function HeatmapLayer({ records }: HeatmapLayerProps) {
  const map = useMap();
  const layerRef = useRef<L.HeatLayer | null>(null);

  useEffect(() => {
    if (layerRef.current) {
      map.removeLayer(layerRef.current);
      layerRef.current = null;
    }

    if (records.length === 0) return;

    const points: L.HeatLatLngTuple[] = records.map((r) => [r.lat, r.lon, 1]);

    layerRef.current = L.heatLayer(points, {
      radius: 25,
      blur: 15,
      maxZoom: 17,
      max: 1,
      gradient: {
        0.2: '#ffffb2',
        0.4: '#fecc5c',
        0.6: '#fd8d3c',
        0.8: '#f03b20',
        1.0: '#bd0026',
      },
    }).addTo(map);

    return () => {
      if (layerRef.current) {
        map.removeLayer(layerRef.current);
        layerRef.current = null;
      }
    };
  }, [records, map]);

  return null;
}
